import React from 'react';
import { PrimaryButton } from '../../../components/Buttons';
import Workflow from './Workflow';
import BirthdayFestivalsContent from './BirthdayFestivalsContent';
import MarketingContent from './MarketingContent';
import PostVisitContent from './PostVisitContent'; 
import NotificationHistory from './NotificationHistory';

function WhatsAppTab({ project, categoryTab, onTabClick, onProjectUpdate }) {
  const tabs = [
    { id: 'leads', label: 'Marketing Campaigns' },
    //{ id: 'campaigns', label: 'Sales Campaigns' },
    // { id: 'birthdays', label: 'Birthdays and Festivals' },
    // { id: 'postVisit', label: 'Post Visit' },
    // { id: 'history', label: 'Notification History' },
  ];

  let content;

  switch (categoryTab) {
    case 'leads':
      content = <Workflow project={project} onProjectUpdate={onProjectUpdate} />;
      break;
  
    default:
      content = (
        <div>
          <p>No content defined for WhatsApp for this category tab.</p>
        </div>
      );
  }

  return (
    <div className="flex flex-col h-full">
      <div className="pt-2 border-t px-4 bg-white">
        <div className="w-full flex justify-start border-gray-300">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              className={`
                py-2 px-16 cursor-pointer text-center transition-colors duration-200
                ${
                  categoryTab === tab.id
                    ? 'text-gray-900 border-b-2 border-flamingo-500 font-semibold'
                    : 'text-gray-600 hover:text-gray-800'
                }
              `}
              onClick={() => onTabClick(tab.id)}
            >
              {tab.label}
            </button>
          ))}
        </div>
      </div>
      <div className="flex-1 overflow-auto">
        {content}
      </div>
    </div>
  );
}

export default WhatsAppTab;